export default [
    // africa
    {
        reshort:'africa',
        position: {x:1.070, y:-1.36, z:0},
        name: 'Africa',
        countries : 'Gabon, South Africa'
    },
    // central east europe
    {
        reshort:'centraleasteurope',
        position: {x:3, y:4, z:0},
        name: 'Central & Eastern Europe',
        countries : 'Bulgaria, Croatia, Czechia, Hungary, Poland, Russia, Serbia, Slovak Republic, Slovenia'
    },
        // east asia
    {
        reshort:'eastasia',
        position: {x:8, y:1.5, z:0},
        name: 'East Asia',
        countries : 'China, Hong Kong S.A.R., Hong Kong, PRC, South Korea, Japan, Korea Rep., Korea'
    },
    // middleeast
    {
        reshort:'middleeast',
        position: {x:3, y:1, z:0},
        name: 'Middle East',
        countries : 'Bahrain, Iran, Iraq, Islamic Rep., Kuwait, Oman, Qatar, Saudi Arabia, Saudi, Turkey, Turkiye, United Arab Emirates, UAE'
    },
    
    // North America
    {
        reshort:'northamerica',
        position: {x:-10.7, y:3.16, z:0},
        name: 'North America',
        countries : 'Canada, Mexico, United States of America, United States, US, USA'
    },

    // North Europe 
    {
        reshort:'northeurope',
        position:  {x:-0.41, y:4.74, z:0},
        name: 'Northern Europe',
        countries : 'Denmark, Estonia, Finland, Iceland, Latvia, Lithuania, Norway, Sweden'
    },

    // Oceania
    { 
        reshort:'oceania',
        position: {x:12, y:-4.7, z:0},
        name: 'Oceania',
        countries : 'Australia, New Zealand'
    },

    // South America
     
    {
        reshort:'southamerica',
        position:   {x:-6.8, y: -2, z: 0},
        name: 'South America',
        countries : 'Argentina, Brazil, Chile'
    },

    //  South Asia
    {
        reshort:'southasia',
        position: {x:6, y:1, z:0},
        name: 'South Asia',
        countries : 'Bangladesh, India'
    },

    //  South East Asia
    {
        reshort:'southeastasia',
        position: {x:9.5, y:-1.5, z:0},
        name: 'Southeast Asia',
        countries : 'Indonesia, Malaysia, Singapore'
    },

    // South Europe

    {
        reshort:'southeurope',
        position: {x:-1.7, y:2.26, z:0},
        name: 'Southern Europe',
        countries : 'Greece, Italy, Malta, Montenegro, Portugal, Spain'
    },

    // West Europe
    {
        reshort:'westeurope',
        position:{x:-1.49, y:3.520, z:0},
        name: 'Western Europe',
        countries : 'Austria, Belgium, France, Germany, Ireland, Luxembourg, Netherlands, Switzerland, United Kingdom, UK, England'
    },
    
  
   
   
 
]